import { useQuery } from '@tanstack/react-query';
import { api } from './api';

// Adjuntos de cualquier entidad (/api/adjuntos?entidad=…&id=…). Quién los ve, sube y borra lo decide la política del
// módulo dueño de la entidad (ticket, solicitud de proyecto, proyecto…).

export interface Attachment {
  id: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  uploadedBy: string;
  uploadedByName: string | null;
  createdAt: string;
}

export const attachmentsKey = (entity: string, entityId: string) => ['adjuntos', entity, entityId] as const;
export const useAttachments = (entity: string, entityId: string) =>
  useQuery({ queryKey: attachmentsKey(entity, entityId), queryFn: () => api<Attachment[]>(`/api/adjuntos?entidad=${entity}&id=${entityId}`) });

/** Sube un archivo como adjunto de la entidad. */
export function uploadAttachment(entity: string, entityId: string, file: File) {
  const data = new FormData();
  data.append('archivo', file);
  return api<Attachment>(`/api/adjuntos?entidad=${entity}&id=${entityId}`, { body: data });
}

/** Lo que acepta la API (apps/api/src/attachments/file-types.ts). */
export const ATTACHMENT_ACCEPT = '.pdf,.png,.jpg,.jpeg,.gif,.webp,.docx,.xlsx,.pptx,.zip,.txt,.log,.csv';

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 ** 2).toLocaleString('es-PA', { maximumFractionDigits: 1 })} MB`;
}
